module.exports = __webpack_public_path__ + "static/Weapon_Halberd_3D-0b8c625f3c5fbf7f5dbf598e057e7fe6.png";